module.exports = __webpack_public_path__ + "static/media/re.ee960ac9.png";